import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import useAuthStore from '@/stores/authStore';
import LandingPage from '@/pages/LandingPage';

/**
 * Component that shows the landing page for unauthenticated users
 * and redirects authenticated users to the dashboard
 */
export function AuthenticatedRoute() {
  const { isAuthenticated, isLoading, organization, user } = useAuthStore();
  const [searchParams] = useSearchParams();

  // Detect Stripe checkout success and persist a short-lived marker
  const checkoutSuccess = searchParams.get('checkout') === 'success' || searchParams.has('session_id');
  useEffect(() => {
    if (checkoutSuccess) {
      try {
        localStorage.setItem('rr_last_checkout_success_at', String(Date.now()));
      } catch {}
      try {
        const url = new URL(window.location.href);
        url.searchParams.delete('checkout');
        url.searchParams.delete('session_id');
        window.history.replaceState({}, '', url.toString());
      } catch {}
    }
  }, [checkoutSuccess]);

  // Show nothing while loading auth state
  if (isLoading) {
    return null;
  }

  // If authenticated, send subscribed users to dashboard, others to billing
  if (isAuthenticated) {
    const sub = (organization as any)?.billing?.subscriptions?.riderelease || (organization as any)?.subscription;
    const status = String(sub?.status || '').toLowerCase();
    // Admin allowlist to bypass subscription gating
    const BYPASS_EMAILS = ['sophie@quarryside.com', 'sophie@quarrygrove.com'];
    const bypass = !!(user as any)?.email && BYPASS_EMAILS.includes(String((user as any).email).toLowerCase());
    let recentCheckoutSuccess = false;
    try {
      const ts = Number(localStorage.getItem('rr_last_checkout_success_at') || '0');
      recentCheckoutSuccess = ts > 0 && (Date.now() - ts) < 60 * 60 * 1000; // 60 minutes window
    } catch {}
    const allowed = bypass || status === 'active' || status === 'trial' || status === 'trialing' || checkoutSuccess || recentCheckoutSuccess;
    return <Navigate to={allowed ? '/dashboard' : '/settings?tab=billing&upgrade=required'} replace />;
  }

  // If not authenticated, show landing page
  return <LandingPage />;
}